import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { getBioEntity, getMultiBioEntity } from '@/redux/bioEntity/bioEntity.thunks';
import { DEFAULT_ERROR } from '@/constants/errors';
import { BioEntityContentsState } from './bioEntity.types';

export const toggleIsContentTabOpenedReducer = (
  state: BioEntityContentsState,
  action: PayloadAction<boolean>,
): void => {
  state.isContentTabOpened = action.payload;
};

export const getBioEntityReducer = (
  builder: ActionReducerMapBuilder<BioEntityContentsState>,
): void => {
  builder.addCase(getBioEntity.pending, (state, action) => {
    state.search.data.push({
      searchQueryElement: action.meta.arg.searchQuery,
      data: undefined,
      loading: 'pending',
      error: DEFAULT_ERROR,
    });
  });
  builder.addCase(getBioEntity.fulfilled, (state, action) => {
    const bioEntities = state.search.data.find(
      bioEntity => bioEntity.searchQueryElement === action.meta.arg.searchQuery,
    );
    if (bioEntities) {
      bioEntities.data = action.payload?.content;
      bioEntities.loading = 'succeeded';
    }
  });
  builder.addCase(getBioEntity.rejected, (state, action) => {
    const bioEntities = state.search.data.find(
      bioEntity => bioEntity.searchQueryElement === action.meta.arg.searchQuery,
    );
    if (bioEntities) {
      bioEntities.loading = 'failed';
    }
  });
};

export const getMultiBioEntityReducer = (
  builder: ActionReducerMapBuilder<BioEntityContentsState>,
): void => {
  builder.addCase(getMultiBioEntity.pending, state => {
    state.searchedModelElementsIds = [];
    state.searchedReactionsIds = [];
    state.search.data = [];
    state.search.loading = 'pending';
  });
  builder.addCase(getMultiBioEntity.fulfilled, (state, action) => {
    const { searchedModelElements, searchedReactions } = action.payload;
    state.searchedModelElementsIds = searchedModelElements;
    state.searchedReactionsIds = searchedReactions;
    state.search.loading = 'succeeded';
  });
  builder.addCase(getMultiBioEntity.rejected, state => {
    state.search.loading = 'failed';
  });
};

export const clearBioEntitySearchDataReducer = (state: BioEntityContentsState): void => {
  state.search.data = [];
  state.search.loading = 'idle';
};
